<div
  [matTooltip]="tooltipTextLimited()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltipDisabled]="isTooltipDisabled()"
  [style.width.px]="size() || defaultSize"
  [style.height.px]="size() || defaultSize"
  [style.background]="user()?.avatarUrl ? 'transparent' : userColor()"
  class="container"
>
  @switch (type()) {
    @case ('user') {
      @if (user()?.avatarUrl || imgUrl()) {
        <img
          draggable="false"
          class="oph-avatar__img"
          [alt]="userFullName()"
          [src]="user()?.avatarUrl || imgUrl()"
          [ngStyle]="imgCustomStyle()"
        />
      } @else if (user()?.firstName && user()?.lastName) {
        <span>{{ user().firstName | userAvatar: 1 }}{{ user().lastName | userAvatar: 1 }}</span>
      } @else if (empty()) {
        <span></span>
      } @else {
        <span>?</span>
      }
    }
    @case ('other') {
      <span>{{ name() | userAvatar: 1 }}</span>
    }
    @default {
      <span>{{ name() || '?' }}</span>
    }
  }
</div>
